var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.4804,
    height: 32.4804,
    rx: 10,
    fill: "#FF704B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1375 11.0747H21.1467M11.5321 6.95807H20.6801C23.2063 6.95807 25.2541 9.00592 25.2541 11.5321V20.6801C25.2541 23.2062 23.2063 25.2541 20.6801 25.2541H11.5321C9.00598 25.2541 6.95813 23.2062 6.95813 20.6801V11.5321C6.95813 9.00592 9.00598 6.95807 11.5321 6.95807ZM19.7653 15.5297C19.8782 16.2911 19.7482 17.0686 19.3937 17.7518C19.0392 18.435 18.4783 18.989 17.7908 19.335C17.1034 19.681 16.3243 19.8015 15.5644 19.6792C14.8045 19.5569 14.1025 19.1982 13.5583 18.6539C13.014 18.1097 12.6553 17.4077 12.533 16.6478C12.4107 15.8879 12.5311 15.1088 12.8772 14.4213C13.2232 13.7339 13.7772 13.173 14.4604 12.8185C15.1436 12.464 15.9211 12.334 16.6824 12.4469C17.459 12.562 18.178 12.9239 18.7331 13.479C19.2883 14.0342 19.6502 14.7531 19.7653 15.5297Z",
    stroke: "white",
    strokeWidth: 1.01217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.7fd1c8f24f26442c21779f9f39e41d21.svg";
export { ForwardRef as ReactComponent };